export const inspectionType = [
  {
    label: 'Final Random Inspection',
    value: 'Final Random Inspection'
  },
  {
    label: 'Loading Inspection',
    value: 'Loading Inspection'
  },
  {
    label: 'During-production Inspection',
    value: 'During-production Inspection'
  },
  {
    label: 'Re-Inspection',
    value: 'Re-Inspection'
  },
  {
    label: 'Initial Production Inspection',
    value: 'Initial Production Inspection'
  },
  {
    label: 'Fabric Inspection',
    value: 'Fabric Inspection'
  },
  {
    label: '100% Inspection',
    value: '100% Inspection'
  },
  {
    label: 'Vendor Own Inspection',
    value: 'Vendor Own Inspection'
  },
  {
    label: 'Sample Collection',
    value: 'Sample Collection'
  },
  {
    label: 'Other',
    value: 'Other'
  }
];

export const inspectionLevel = [
  {
    label: 'General Inspection Level I',
    value: 'i'
  },
  {
    label: 'General Inspection Levels II',
    value: 'ii'
  },
  {
    label: 'General Inspection Levels III',
    value: 'iii'
  },
  {
    label: 'Special Inspection Levels, S-1',
    value: 's1'
  },
  {
    label: 'Special Inspection Levels, S-2',
    value: 's2'
  },
  {
    label: 'Special Inspection Levels, S-3',
    value: 's3'
  },
  {
    label: 'Special Inspection Levels, S-4',
    value: 's4'
  }
];

export const AQLLevel = [
  {
    label: '0',
    value: 0,
  },
  {
    label: '0.065',
    value: 0.065,
  },
  {
    label: '0.1',
    value: 0.1,
  },
  {
    label: '0.15',
    value: 0.15,
  },
  {
    label: '0.25',
    value: 0.25,
  },
  {
    label: '0.4',
    value: 0.4,
  },
  {
    label: '0.65',
    value: 0.65,
  },
  {
    label: '1.0',
    value: 1.0,
  },
  {
    label: '1.5',
    value: 1.5,
  },
  {
    label: '2.5',
    value: 2.5,
  },
  {
    label: '4.0',
    value: 4.0,
  },
  {
    label: '6.5',
    value: 6.5,
  }
];

